import{useFormikFieldValidation as r}from"../../../../../hooks/useFormikFieldValidation/useFormikFieldValidation.js";const n=(i,o)=>{const{isInvalid:e}=r(i,o);return{isInvalid:e}};export{n as useFormikCheckboxField};
